<template>
  <b-container>
    <b-row>
      <b-col></b-col>
      <b-col cols="auto" style="width: 400px">
        <h2>Forgot Password</h2>
        <b-row>
          <b-col>
            <b-form v-if="showForm" @submit.prevent="forgotPasswordSubmit">
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
                :invalid-feedback="forgotPasswordFeedback"
                :state="errors.length == 0 ? null : forgotPasswordState"
                description="Please enter the account's email address">
                <b-form-input id="forgot-password-email"
                  :state="errors.length == 0 ? null : forgotPasswordState"
                  v-model.trim="forgotPasswordForm.email"
                  required>
                </b-form-input>
              </b-form-group>
              <b-button 
                type="submit" 
                variant="primary" 
                class="float-right ml-2" 
                :disabled="isSending">
                <b-spinner small v-if="isSending" label="Spinning"></b-spinner>
                <div v-else>Submit</div>
              </b-button>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseMessageBlock :messages="errors"></BaseMessageBlock>
            <BaseMessageBlock type="Success" :messages="messages"></BaseMessageBlock>
          </b-col>
        </b-row>
        <b-link v-if="showBackToLogin" to="/login">Back to login </b-link>
      </b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ForgotPassword",
  data() {
    return {
      errors: [],
      messages: [],
      isSending: false,
      showForm: true,
      showBackToLogin: false,
      forgotPasswordForm: {
        email: ''
      }
    }
  },
  methods: {
    forgotPasswordSubmit() {
      if (this.forgotPasswordState) {
        this.isSending = true;
        this.errors = [];
        this.messages = [];

        axios
          .post(`${this.$api_url}/identity/forgot-password/${this.forgotPasswordForm.email}`, this.getReqConfig())
          .then(() => {
            this.messages.push({ message: `An email has been sent to ${this.forgotPasswordForm.email}. Follow the instructions in the email to reset your password.`})
            this.showForm = false;
            this.showBackToLogin = true;
          })
          .catch((response) => {
            this.errors.push(...this.$helpers.formatErrors(response));
          })
          .finally(() => {
            this.isSending = false;
          })
      }
    }
  },
  computed: {
    forgotPasswordState() {
      if (this.forgotPasswordFeedback == null) return null;
      return this.forgotPasswordFeedback.length === 0;
    },
    forgotPasswordFeedback() {
      let input = this.forgotPasswordForm.email;
      if (input.length === 0) {
        return null;
      }

      let re =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(input)){
        return "Email is not valid";
      } else {
        return "";
      }
    }
  }
}
</script>